export default {"src":"/_next/static/media/icon-people.3372e964.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};